import { ProviderTemplate } from './types';

export const infrastructureProviders: Record<string, ProviderTemplate> = {
  cloudflare: {
    name: 'Cloudflare',
    icon: '☁️',
    description: 'Global CDN & DNS',
    fields: [
      {
        key: 'api_token',
        label: 'API Token',
        type: 'password',
        required: true,
        help: 'Get your API token from Cloudflare Dashboard > Profile > API Tokens',
      },
      {
        key: 'zone_id',
        label: 'Zone ID (Optional)',
        type: 'text',
        required: false,
        help: 'Leave empty to sync all zones, or specify a specific zone ID',
      },
      {
        key: 'email',
        label: 'Account Email',
        type: 'email',
        required: false,
        help: 'Your Cloudflare account email (for legacy auth)',
      },
    ],
    docsUrl: 'https://developers.cloudflare.com/api/tokens/create',
  },
  digitalocean: {
    name: 'DigitalOcean DNS',
    icon: '🌊',
    description: 'Cloud Infrastructure',
    fields: [
      {
        key: 'api_token',
        label: 'API Token',
        type: 'password',
        required: true,
        help: 'DigitalOcean API token with read/write permissions',
      },
    ],
    docsUrl: 'https://docs.digitalocean.com/reference/api/api-reference/#tag/Domains',
  },
  linode: {
    name: 'Linode DNS',
    icon: '🟢',
    description: 'Cloud Computing',
    fields: [
      {
        key: 'api_token',
        label: 'API Token',
        type: 'password',
        required: true,
        help: 'Linode API token with DNS read/write permissions',
      },
    ],
    docsUrl: 'https://www.linode.com/api/docs/',
  },
  vultr: {
    name: 'Vultr DNS',
    icon: '🔵',
    description: 'Cloud Infrastructure',
    fields: [
      {
        key: 'api_key',
        label: 'API Key',
        type: 'password',
        required: true,
        help: 'Vultr API key from your account',
      },
    ],
    docsUrl: 'https://www.vultr.com/api/',
  },
  ovh: {
    name: 'OVH Cloud DNS',
    icon: '🔵',
    description: 'European Cloud Provider',
    fields: [
      {
        key: 'application_key',
        label: 'Application Key',
        type: 'text',
        required: true,
        help: 'OVH API application key',
      },
      {
        key: 'application_secret',
        label: 'Application Secret',
        type: 'password',
        required: true,
        help: 'OVH API application secret',
      },
      {
        key: 'consumer_key',
        label: 'Consumer Key',
        type: 'password',
        required: true,
        help: 'OVH API consumer key',
      },
      {
        key: 'endpoint',
        label: 'Endpoint',
        type: 'select',
        required: true,
        options: [
          'ovh-eu',
          'ovh-us',
          'ovh-ca',
          'kimsufi-eu',
          'kimsufi-ca',
          'runabove-ca',
          'soyoustart-eu',
          'soyoustart-ca',
        ],
        help: 'OVH API endpoint region',
      },
    ],
    docsUrl: 'https://docs.ovh.com/gb/en/api/',
  },
  hetzner: {
    name: 'Hetzner DNS',
    icon: '🟠',
    description: 'European Cloud Provider',
    fields: [
      {
        key: 'api_token',
        label: 'API Token',
        type: 'password',
        required: true,
        help: 'Hetzner API token from your account',
      },
    ],
    docsUrl: 'https://docs.hetzner.com/dns-console/dns-api/overview/',
  },
  ns1: {
    name: 'NS1 DNS',
    icon: '🟦',
    description: 'Intelligent DNS Platform',
    fields: [
      {
        key: 'api_key_ns1',
        label: 'API Key',
        type: 'password',
        required: true,
        help: 'NS1 API key from your account settings',
      },
    ],
    docsUrl: 'https://ns1.com/api',
  },
};